import { HashMap } from '../../constants';
import { Loadable } from '../../models';
import { QueryResult } from '../../models/queryResult';
import { ComplexSearchFilter } from '../../models/searchFilter';
import { Sim, SimInfo } from '../sim';
import { Provisioning } from '../provision';
import {
  DirectlyAvailableSimCommandTypesState,
  getDefaultDirectlyAvailableCommandTypesState
} from './directlyAvailableCommandTypeState';

/**
 * The number of seconds the application will wait before refreshing SIMs from the server.
 */
export const SimsCacheTimeout = 3600;

export type SimsState = Loadable<{
  /** The search filter */
  searchFilter: ComplexSearchFilter;

  /** An array containing a flat list of all the loaded SIMs. */
  all: QueryResult<Sim>;

  /** Gets a list of command types currently directly-available */
  directlyAvailableCommandTypes: DirectlyAvailableSimCommandTypesState;

  /** An array containing a flat list of all the loaded SIMs, organized by identifier. */
  simsById: HashMap<Sim>;

  /** An array containing a flat list of all the currently selected SIMs, organised by identifier. */
  selected: HashMap<SimInfo>;

  /**An array containing flat list of all sims being viewed  */
  viewed: HashMap<SimInfo>;
}>;

export type ProvisioningState = Loadable<Provisioning>;

export const getDefaultProvisioningState = (): ProvisioningState => {
  return {
    subscriberId: '',
    isLoading: false,
    purchaseOrderNumber: undefined,
    standardBoltOns: [],
    temporalBoltOns: [],
    provisioningOrder: undefined,
    publicIpAddress: undefined,
    staticIpAddress: undefined
  };
};

export const getDefaultSimsState = (): SimsState => {
  return {
    directlyAvailableCommandTypes: getDefaultDirectlyAvailableCommandTypesState(),
    searchFilter: {
      companyId: 0,
      filters: {},
      sortModel: [{ colId: 'serialNumber', sort: 'asc' }]
    },
    all: {
      result: []
    },
    selected: {},
    viewed: {},
    simsById: {},
    isLoading: false
  };
};
